/**
 * Style constants used in default theme.
 */

const FONT_FAMILY_BASE =
  'Barlow, Roboto, -apple-system, "BlinkMacSystemFont", "Segoe UI", "Helvetica Neue", Helvetica, sans-serif';
const FONT_FAMILY_CODE = 'Consolas, Menlo, Courier, monospace';

const FONT_SIZE_BASE = 14;
const FONT_SIZE_SMALL = 12;
const FONT_SIZE_LARGE = 16;

const COLOR_PRIMARY = '#7C4EF6';
const COLOR_SECONDARY = '#FEC34C';

const GLOBAL_HEADER__BACKGROUND_COLOR = '#fff';
const GLOBAL_HEADER__HEIGHT = 64;
const GLOBAL_HEADER__PADDING_X = 20;
const GLOBAL_HEADER__ENABLE_SHADOW = true;
const GLOBAL_HEADER__SHADOW_OFFSET_Y = 1;
const GLOBAL_HEADER__SHADOW_BLUR_RADIUS = 8;
const GLOBAL_HEADER__SHADOW_COLOR = 'rgba(40,40,40,.05)';
const GLOBAL_HEADER__ZINDEX = 101;

const GLOBAL_FOOTER__BACKGROUND_COLOR = 'transparent';
const GLOBAL_FOOTER__HEIGHT = 40;
const GLOBAL_FOOTER__PADDING_X = 20;

const GLOBAL_SIDER__WIDTH = 240;
const GLOBAL_SIDER__BACKGROUND_COLOR = '#1B202A';
const GLOBAL_SIDER__ZINDEX = 101;

// Table
const TABLE__BORDER_WIDTH = 1;
const TABLE__BORDER_COLOR = '#e8e8e8';

const TABLE__BORDER_RADIUS_BASE = 4;
const TABLE__BORDER_RADIUS_SMALL = 4;
const TABLE__BORDER_RADIUS_LARGE = 4;

export default {
  FONT_FAMILY_BASE,
  FONT_FAMILY_CODE,

  FONT_SIZE_BASE,
  FONT_SIZE_SMALL,
  FONT_SIZE_LARGE,

  COLOR_PRIMARY,
  COLOR_SECONDARY,

  GLOBAL_HEADER__BACKGROUND_COLOR,
  GLOBAL_HEADER__HEIGHT,
  GLOBAL_HEADER__PADDING_X,
  GLOBAL_HEADER__ENABLE_SHADOW,
  GLOBAL_HEADER__SHADOW_OFFSET_Y,
  GLOBAL_HEADER__SHADOW_BLUR_RADIUS,
  GLOBAL_HEADER__SHADOW_COLOR,
  GLOBAL_HEADER__ZINDEX,

  GLOBAL_FOOTER__BACKGROUND_COLOR,
  GLOBAL_FOOTER__HEIGHT,
  GLOBAL_FOOTER__PADDING_X,

  GLOBAL_SIDER__WIDTH,
  GLOBAL_SIDER__BACKGROUND_COLOR,
  GLOBAL_SIDER__ZINDEX,

  TABLE__BORDER_WIDTH,
  TABLE__BORDER_COLOR,

  TABLE__BORDER_RADIUS_BASE,
  TABLE__BORDER_RADIUS_SMALL,
  TABLE__BORDER_RADIUS_LARGE
};



// WEBPACK FOOTER //
// ./src/theme/styleConsts.ts